import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";
import { CardList } from "../CardList";

class TreatmentCenterList extends Component {
  render() {
    const { action, newTreatmentCenter, editTreatmentCenter } = this.props;
    const treatmentCenters = this.props.treatmentCenters.filter(tc => !tc._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Facility Name</th>
            <th>Length of Stay</th>
            <th>Admitted At</th>
            <th>Discharged At</th>
            <th>Reason for Discharge</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            treatmentCenters.map((tc, i) => {
              return (
                <tr key={i}>
                  <td>{tc.name}</td>
                  <td>
                    {
                      tc.started_at &&
                      `${moment(tc.ended_at || moment()).diff(moment(tc.started_at), 'days')} days`
                    }
                  </td>
                  <td>{tc.started_at && moment(tc.started_at).format("MM/DD/YYYY")}</td>
                  <td>{tc.ended_at && moment(tc.ended_at).format("MM/DD/YYYY")}</td>
                  <td>{tc.reason_for_discharge}</td>
                  <td>
                    {
                      action === "edit" &&
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.editTreatmentCenter(tc);
                        }}>
                        Edit
                      </a>
                    }
                  </td>
                </tr>
              );
            })
          }
          {
            action == "edit" &&
            <tr>
              <td colSpan={6} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newTreatmentCenter();
                  }}>
                  Add Treatment Center
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    treatmentCenters: state.treatment_centers,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    newTreatmentCenter: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "treatmentCenter" }
      })
    },
    editTreatmentCenter: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: {
          resourceName: "treatmentCenter",
          resource
        }
      })
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TreatmentCenterList);
